<template>
	<el-row class="points-show">
		<el-col :span="23" style="justify-content: space-between">
			<div>业务阶段管理</div>
			<el-button type="danger" size="mini" @click="DescriptionOfTaskDivision = true">用户阶段说明</el-button>
		</el-col>
		<el-divider></el-divider>
		<div>
			<!-- 列表结构 -->
			<el-col :span="24" style="overflow-x: hidden; overflow-y: auto; flex-wrap: wrap">
				<div class="waterfall">
					<div v-for="(value, index1) in allModularList" :key="index1" class="item">
						<el-card class="box-card block-warp" v-for="(item, index2) in value.paiboModularDTOS"
							:key="index2" shadow="hover">
							<div slot="header" class="clearfix">
								<el-row type="flex" class="row-bg" justify="space-between">
									<el-col :span="16">
										<span>{{ item.modularName }}</span>
									</el-col>
									<el-col :span="5">
										<el-tag style="float: right">
											{{item.parentModularName}}
										</el-tag>
									</el-col>
								</el-row>
							</div>
							<div>
								<el-row type="flex" class="row-bg" justify="space-between">
									<el-col :span="16">
										<div class="grid-content" style="font-weight: 600">
											常规任务设置
										</div>
									</el-col>
									<el-col :span="7">
										<div class="grid-content">
											<el-button style="float: right; padding: 3px 0" type="text"
												@click="classDrawer = true">添加可发放课程</el-button>
										</div>
									</el-col>
								</el-row>
								<div class="scroll-view">
									<el-row type="flex" class="row-bg class_item" justify="space-between"
										v-for="index in 8" :key="index">
										<el-col :span="16">
											<div class="grid-content">禧念珠宝防坑课</div>
										</el-col>
										<el-col :span="4">
											<div class="grid-content">
												<el-button size="mini" icon="el-icon-minus" plain circle></el-button>
											</div>
										</el-col>
									</el-row>
								</div>
							</div>
							<div>
								<el-row type="flex" class="row-bg" justify="space-between">
									<el-col :span="16">
										<div class="grid-content" style="font-weight: 600">
											常规任务设置
										</div>
									</el-col>
									<el-col :span="7">
										<div class="grid-content">
											<el-button @click="classDrawer = true" style="float: right; padding: 3px 0"
												type="text">添加可发放课程</el-button>
										</div>
									</el-col>
								</el-row>
								<div class="scroll-view">
									<el-row type="flex" class="row-bg class_item" justify="space-between"
										v-for="index in 8" :key="index">
										<el-col :span="16">
											<div class="grid-content">禧念珠宝防坑课</div>
										</el-col>
										<el-col :span="4">
											<div class="grid-content">
												<el-button size="mini" icon="el-icon-minus" plain circle></el-button>
											</div>
										</el-col>
									</el-row>
								</div>
							</div>
						</el-card>
					</div>
				</div>
			</el-col>
		</div>

		<!-- 添加课程弹窗============================ -->
		<el-drawer title="添加课程" :visible.sync="classDrawer" :direction="direction" :before-close="handleClose"
			size="60%">
			<el-row :gutter="9" style="padding: 0 20px">
				<el-col :span="6">
					<div class="search-view">
						<div>课程名称：</div>
						<el-input size="mini" placeholder="请课程名称" v-model="coursename" clearable />
					</div>
				</el-col>
				<el-col :span="6">
					<div class="search-view">
						<div>关联品类：</div>
						<el-select filterable size="mini" v-model="category" placeholder="请选择关联品类">
							<el-option v-for="item in matVarietyList" :key="item.dicId" :label="item.dicDesc"
								:value="item.dicId">
							</el-option>
						</el-select>
					</div>
				</el-col>
				<el-col :span="6">
					<div class="search-view">
						<div>课程状态：</div>
						<el-select v-model="status" size="mini" clearable placeholder="请选择">
							<el-option v-for="item in classStatus" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
				</el-col>
				<el-col :span="4">
					<el-button type="primary" size="mini" @click="handleSizeChange()">查询</el-button>
					<el-button type="success" size="mini" icon="el-icon-plus" @click="switchDialog('classForm')">增加
					</el-button>
				</el-col>
			</el-row>
			<div style="padding: 0 20px">
				<el-table :data="classData" style="width: 100%" :height="tableHeight">
					<el-table-column prop="courseId" label="课程id" width="65">
					</el-table-column>
					<el-table-column prop="courseName" label="课程标题" width="180">
					</el-table-column>
					<el-table-column prop="themePic" label="主题图片">
						<template slot-scope="scope">
							<img style="width: 90px" :src="scope.row.themePic" />
						</template>
					</el-table-column>
					<el-table-column prop="customerStageName" label="课程阶段">
					</el-table-column>
					<el-table-column prop="createTime" label="上传日期">
					</el-table-column>
					<el-table-column prop="status" label="操作" width="200">
						<template slot-scope="scope">
							<el-button size="mini" plain type="primary" @click="editClass(scope.row)">选择课程</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</el-drawer>
		<!-- 弹窗结构============================ -->
		<!-- 弹窗结构============================ -->
		<div>
			<el-col :span="24">
				<el-dialog :visible.sync="DescriptionOfTaskDivision" width="35%" class="DescriptionOfTaskDivision">
					<div class="title">新客任务针对新增到首次下单期间的用户：</div>
					<div class="content">1.新客转化 —— 新增用户时弹出提醒。</div>
					<div class="content">
						2.入门成交 —— 完成新客转化任务后（发放课程）提醒
					</div>
					<div class="content">3.连带销售 —— 新增用户连续7天弹出提醒</div>
					<div class="title">老客任务针对首次下单后的用户：</div>
					<div class="content">1.定向推荐 —— 每次下单后根据价位弹出提醒</div>
					<div class="content">2.沉睡唤醒 —— 加购或未支付时提醒</div>
					<div class="content">3.引导转介绍 —— 完成复购后弹出提醒</div>
					<div class="content">4.转代引导 —— 首次下单后连续7天弹出提醒</div>
					<div class="title">关怀提醒：</div>
					<div class="content">1.入会关怀 —— 用户下单礼包商品后进行提醒</div>
					<div class="content">
						2.成长关怀 ——
						每笔订单按照周期提醒：到货后提醒；到货后15天提醒；到货后1个月提醒。
					</div>
					<div class="content">3.节日关怀 —— 节日提醒</div>
					<div class="content">4.私客关怀 —— 生日提醒</div>
				</el-dialog>
			</el-col>
		</div>
	</el-row>
</template>
<script>
	import httpClient from "../../../util/request.js";
	export default {
		data() {
			return {
				classStatus: [{
						label: "全部",
						value: "",
					},
					{
						label: "上架",
						value: "0",
					},
					{
						label: "下架",
						value: "1",
					},
				],
				uploadUrl: httpClient.imgUrl,
				DescriptionOfTaskDivision: false,
				allModularList: [],
				classDrawer: false,
				direction: "rtl",
			};
		},
		created() {
			this.getAllModularData();
		},
		methods: {
			async getAllModularData() {
				var params = {
					status: 0,
					delete_status: 0,
					memberId: 0,
				};
				var {
					data
				} = await this.$http.post(
					"/api/source/paiboModular/selectAllModular",
					params
				);
				if (data.status == 0) {
					this.allModularList = data.data;
				}
			},

			//查询课程
			queryClass() {
				var coursename = this.coursename;
				var category = this.category;
				var status = this.status;
				this.$http
					.post(
						"/api/source/clrCourse/listPage?pageNum=" +
						this.pageNum +
						"&pageSize=" +
						this.pageSize, {
							courseName: coursename,
							status: status,
							category: category,
						}
					)
					.then((res) => {
						this.classData = res.data.data.list;
						this.total = res.data.data.total;
					});
			},
		},
	};
</script>
<style scoped lang="less">
	.DescriptionOfTaskDivision .title {
		font-weight: 550;
		color: red;
		font-size: 16px;
		margin: 10px 0 5px 0;
	}

	.DescriptionOfTaskDivision .content {
		padding: 2px 0px 2px 10px;
		font-size: 12px;
	}

	.text {
		font-size: 14px;
	}

	.item {
		margin-bottom: 18px;
	}

	.clearfix:before,
	.clearfix:after {
		display: table;
		content: "";
	}

	.clearfix:after {
		clear: both;
	}

	.box-card {
		width: 390px;
		max-height: 430px;
	}

	.block-warp {
		margin-bottom: 10px;
	}

	/deep/.el-col-24 .box-card .el-card__body {
		display: flex;
		flex-direction: column;
		height: 76%;
		padding: 10px;
	}

	/deep/.el-row {
		padding: 0;
	}

	.class_item {
		padding: 5px 0px 5px 15px;
	}

	.scroll-view {
		max-height: 110px;
		overflow-y: scroll;
		overflow-x: hidden;
		margin: 10px;
	}

	.scroll-view::-webkit-scrollbar {
		/*滚动条整体样式*/
		width: 4px;
		/*高宽分别对应横竖滚动条的尺寸*/
		height: 1px;
	}

	.scroll-view::-webkit-scrollbar-thumb {
		/*滚动条里面小方块*/
		border-radius: 2px;
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #66b8ff;
	}

	.scroll-view::-webkit-scrollbar-track {
		/*滚动条里面轨道*/
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 2px;
		background: #ededed;
	}

	.waterfall {
		-moz-column-count: 4;

		/* Firefox */

		-webkit-column-count: 4;

		/* Safari 和 Chrome */

		column-count: 4;

		-moz-column-gap: 1em;

		-webkit-column-gap: 1em;

		column-gap: 1em;
	}

	/*一个内容层*/
	.item {
		// padding: 1em;

		margin: 0 0 1em 0;

		/* -moz-page-break-inside: avoid; */

		-webkit-column-break-inside: avoid;

		break-inside: avoid;

		// border: 1px solid #000;
	}
</style>
